import { useState , useEffect } from "react";


const useWindowSize = ()=> {
    const ULTRA_WIDE_WIDTH = 3000;
    const [windowSize, setWindowSize]: any = useState({
        width: undefined,
        height: undefined
    })
    const [isUltraWide, setIsUltraWide]: any = useState(false)

    useEffect(()=>{
        const handleResize = ()=> {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            })
            // Check if the display is ultra wide or not
            setIsUltraWide(window.innerWidth >= ULTRA_WIDE_WIDTH);
        }

        // Initial window size
        handleResize();

        // When window is resized
        window.addEventListener("resize", handleResize);


        const cleanup = ()=> {
            // console.log('Runs in dependency');
            window.removeEventListener("resize", handleResize);
        }

        return cleanup

    }, [])


    return {...windowSize, isUltraWide};
}


export default useWindowSize;